document.addEventListener('DOMContentLoaded', function() {
  class SearchDrawer extends HTMLElement {
    constructor() {
      super();
      // Gestire la chiusura con il tasto Escape
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      // Gestire la chiusura con il click sull'overlay
      this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Inizializzare gli event listener sull'icona di ricerca
      this.initSearchIconListeners();
    }

    initSearchIconListeners() {
      // Trovare tutte le icone di ricerca e assegnare l'event listener
      const searchIcons = document.querySelectorAll('[id*="searchIconHeader"]');
      searchIcons.forEach((icon) => {
        icon.addEventListener('click', this.open.bind(this));
      });
    }

    open() {
      const searchDrawer = document.getElementById('SearchDrawer');
      // I-TL2 16/10/2026 (DECISIONI-MAIN §130): the button that opened the drawer gets the focus back when it closes (activeElement was never set)
      this.opener = document.activeElement;
      // Aggiungere le classi animate e active
      setTimeout(() => { searchDrawer.classList.add('animate', 'active'); });

      // Focus goes to the search field (the old target, .drawer__inner, is a div that cannot take focus:
      // focus stayed on the body and typing went nowhere). Fallback timer in case no transitionend reaches the drawer.
      const searchInput = searchDrawer.querySelector('input[type="search"], input[name="q"]');
      let focused = false;
      const focusSearch = () => {
        if (focused) return;
        focused = true;
        const focusElement = searchInput || searchDrawer.querySelector('.drawer__close');
        trapFocus(searchDrawer, focusElement);
      };
      searchDrawer.addEventListener('transitionend', focusSearch, { once: true });
      setTimeout(focusSearch, 500);

      // Prevenire lo scrolling del body
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');
    }

    close() {
      const searchDrawer = document.getElementById('SearchDrawer');
      searchDrawer.classList.remove('active');
      removeTrapFocus(this.opener && document.contains(this.opener) ? this.opener : null);
      this.opener = null;
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }

  customElements.define('search-drawer', SearchDrawer);
});

// Assicurati che le funzioni trapFocus e removeTrapFocus siano definite altrove nel tuo script.
